import React, { useMemo } from 'react';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Eye, Download } from 'lucide-react';
import type { ParsedLine } from '@/lib/leadsheetParser';
import { lagOppsett } from '@/lib/sang/oppsett';
import type { PdfHode } from '@/lib/sang/pdf';
import { SangSider } from './SangSider';

interface PreviewSectionProps {
  tekstOgAkkorder: string;
  linjer: ParsedLine[];
  hode: PdfHode;
  fontSize: number;
  chordFontSize: number;
  chordColor: string;
  columns: 1 | 2;
  onDownloadPDF: () => void;
}

export const PreviewSection: React.FC<PreviewSectionProps> = ({
  tekstOgAkkorder,
  linjer,
  hode,
  fontSize,
  chordFontSize,
  chordColor,
  columns,
  onDownloadPDF,
}) => {
  const oppsett = useMemo(
    () => lagOppsett(linjer, { fontSize, chordFontSize, columns }),
    [linjer, fontSize, chordFontSize, columns]
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label className="flex items-center gap-2 text-base font-semibold">
          <Eye className="h-5 w-5 text-primary" />
          Forhåndsvisning
        </Label>
        <Button 
          variant="outline" 
          size="sm" 
          className="gap-2"
          onClick={onDownloadPDF}
          disabled={!tekstOgAkkorder}
        >
          <Download className="h-4 w-4" />
          Last ned PDF
        </Button>
      </div>
      <div className="border rounded-lg bg-muted/40 p-4 min-h-[400px] overflow-auto shadow-inner">
        {tekstOgAkkorder ? (
          <SangSider hode={hode} oppsett={oppsett} akkordfarge={chordColor} />
        ) : (
          <div className="text-muted-foreground text-center py-12">
            Ingen tekst/akkorder lagt til ennå
          </div>
        )}
      </div>
    </div>
  );
};
